import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import {
  MenuPart,
  RestaurantMenu
} from 'PMT/entities/menu';

import { Modal } from 'react-bootstrap';
import MenuPartForm from './MenuPartForm';

/**
 */
export default class MenuPartFormModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    restaurantMenu: PropTypes.objectOf(RestaurantMenu).isRequired,

    isEditMode: PropTypes.bool.isRequired,

    menuManagedByPos: PropTypes.bool,

    menuPart: PropTypes.objectOf(MenuPart),

    /**
     * @param MenuPart
     */
    onUpdate: PropTypes.func.isRequired,

    /**
     * @param MenuPart
     */
    onDelete: PropTypes.func
  };

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  //
  // renderers
  //

  renderBody() {
    try {
    return (
      <div className="menu_part_form">
        <MenuPartForm
          restaurantMenu={this.props.restaurantMenu}
          isEditMode={this.props.isEditMode}
          menuManagedByPos={this.props.menuManagedByPos}
          menuPart={this.props.menuPart}
          onUpdate={this.props.onUpdate}
          onDelete={this.props.onDelete}
        />
      </div>
    );
  } catch (e) { console.error(e);}
  }

  renderTitle() {
    if (this.props.isEditMode) {
      return (
        <span>
          {I18n.tr('menu.menu_edit.part.title_edit')}
        </span>
      )
    }

    return (
      <span>
        {I18n.tr('menu.menu_edit.part.title_create')}
      </span>
    )
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {this.renderTitle()}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/menu/menuEdit/components/menuPartFormModal/MenuPartFormModal.js